import { useContext } from "react";

import { InsightsContextType, InsightsContextValue } from "./InsightsContext";

export const useInsights = (): InsightsContextType => {
  const context = useContext(InsightsContextValue);

  if (!context) {
    throw new Error("useInsights must be used within an InsightsProvider");
  }

  return context;
};
